
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiGrid, FiEdit, FiShoppingCart, FiUser } from '../assets/icons/vander';

// Bottom Navigation Bar component for mobile view
const BottomNav = () => {
    const location = useLocation(); // Get current route to highlight active tab

    // Navigation items with paths, icons, and labels
    const navItems = [
        { path: "/", Icon: FiHome, label: "Home" },
        { path: "/shop-grid-left-sidebar", Icon: FiGrid, label: "Category" },
        { path: "/customize", Icon: FiEdit, label: "Customize" },
        { path: "/shop-cart", Icon: FiShoppingCart, label: "Cart" },
        { path: "/user-account", Icon: FiUser, label: "Account" },
    ];

    return (
        <nav className="md:hidden z-40  fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-800 shadow-md z-50">
            <ul className="flex justify-around items-center py-2">
                {navItems.map((item) => (
                    <li key={item.label}>
                        <Link
                            to={item.path}
                            className={`flex flex-col items-center p-2 text-xs font-semibold ${location.pathname === item.path
                                    ? "text-green-500"
                                    : "text-slate-900 dark:text-slate-200 hover:text-green-500"
                                }`}
                            aria-label={item.label}
                        >
                            <item.Icon className="size-6" />
                            <span>{item.label}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default BottomNav;
